import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { caseStudies } from '@/mocks/realisations';

const recent = caseStudies.slice(0, 4);

export default function RecentWork() {
  return (
    <section className="relative overflow-hidden bg-background-200 py-16 md:py-20">
      <div className="pointer-events-none absolute inset-0 paper-grid opacity-50" />
      <div className="pointer-events-none absolute inset-x-0 top-0 h-[3px] bg-accent-500" />
      <div className="container-wide relative">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <Reveal>
            <SectionHeading
              label="Réalisations récentes"
              title={
                <>
                  Sortis de
                  <br />
                  l’atelier
                </>
              }
            />
          </Reveal>
          <Reveal delay={100}>
            <div className="md:text-right">
              <p className="max-w-sm text-sm leading-relaxed text-foreground-700 md:ml-auto">
                Quatre chantiers livrés ces derniers mois, du réservoir inox au réseau vapeur.
                Chaque fiche détaille le défi et les contrôles réalisés.
              </p>
              <Link
                to="/realisations"
                className="group mt-4 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap text-xs font-semibold uppercase tracking-[0.12em] text-primary-700 transition-colors hover:text-primary-600"
              >
                Toutes nos réalisations
                <i className="ri-arrow-right-line text-sm transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </div>
          </Reveal>
        </div>

        <div className="-mx-5 mt-10 flex snap-x snap-mandatory gap-3 overflow-x-auto px-5 pb-3 md:mx-0 md:grid md:snap-none md:grid-cols-2 md:overflow-visible md:px-0 lg:grid-cols-4">
          {recent.map((study, index) => (
            <Reveal
              key={study.slug}
              delay={index * 80}
              className="w-[78%] flex-shrink-0 snap-start sm:w-[52%] md:w-auto"
            >
              <Link
                to="/realisations"
                className="group relative flex h-full cursor-pointer flex-col overflow-hidden rounded-lg bg-primary-950 ring-1 ring-inset ring-foreground-950/20"
              >
                <div className="aspect-[4/3] w-full overflow-hidden">
                  <img
                    src={study.image}
                    alt={study.title}
                    title={`${study.title} — SGSCTIC`}
                    className="h-full w-full object-cover object-top transition-transform duration-[900ms] ease-smooth group-hover:scale-[1.06]"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-primary-950 via-primary-950/45 to-transparent" />
                <span className="absolute right-3 top-3 rounded-full bg-background-50/92 px-2.5 py-1 font-label text-[9px] uppercase tracking-[0.14em] text-primary-700">
                  {study.year}
                </span>
                <div className="absolute inset-x-0 bottom-0 p-4">
                  <span className="label-mono text-accent-400">{study.sector}</span>
                  <h3 className="mt-1 font-heading text-lg font-semibold uppercase leading-tight text-background-50">
                    {study.title}
                  </h3>
                  <div className="mt-2.5 flex items-center justify-between gap-3 border-t border-background-50/15 pt-2.5 text-[10px] uppercase tracking-[0.12em] text-background-300">
                    <span className="truncate">{study.scope}</span>
                    <i className="ri-arrow-right-up-line text-sm text-accent-400 transition-transform duration-300 group-hover:-translate-y-0.5" />
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}